import { ModelFilters } from 'modules/Models/components/ModelFilters/ModelFilters';
import { useListingEntityType } from 'modules/Listings/store/useCurrentStore';
import { ENTITY_SLUGS } from 'modules/Listings/store/CurrentStoreContext';
import { sidebarPanel } from './styles';

export interface SidebarFilterProps extends React.HTMLAttributes<HTMLDivElement> {
  defaultOpen?: boolean;
  isModalView?: boolean;
}

export const FilterArea: import('react').FC<SidebarFilterProps> = (p) => {
  const entityType = useListingEntityType();

  return (
    <div className={sidebarPanel} data-testid="listSidebarFilters" {...p}>
      {entityType === ENTITY_SLUGS.models && <ModelFilters />}
    </div>
  );
};
